import React, { useState } from "react";

import useWindowSize from "../hooks/useWindowSize";
import { IconName, Promotion } from "../types";
import EllipsisLoader from "./EllipsisLoader";
import Icon from "./Icon";
import MoreDetailsBtn from "./MoreDetailsBtn";
import Selectable from "./Selectable";

const PromotionBanner = (props: {
  promotion: Promotion;
  selected: boolean;
  selectableHidden?: boolean;
  onClick?: (promotion: Promotion) => void;
  onClickMoreDetails?: (promotion: Promotion) => void;
  showPopout: boolean;
}) => {
  const windowSize = useWindowSize();
  const [isPopoutVisible, setIsPopoutVisible] = useState(true);

  const onClickMoreDetails = () => {
    if (props.onClickMoreDetails) {
      props.onClickMoreDetails(props.promotion);
    }
  };

  const closePopout = () => {
    setIsPopoutVisible(false);
  };

  return (
    <Selectable
      selected={props.selected}
      hidden={props.selectableHidden}
      insetTick={windowSize.width < 768}
      className={"pyht-special-offer-banner"}
    >
      <>
        <div
          className={"inner"}
          role={"button"}
          onClick={() => props.onClick && props.onClick(props.promotion)}
        >
          <div className="image">
            <EllipsisLoader />
            <img
              src={props.promotion.background_image_desktop}
              alt={""}
            />
          </div>
          <div className="text">
            <h2>{ props.promotion.title }</h2>
            <div className="promo-copy" dangerouslySetInnerHTML={{ __html: props.promotion.estimate_copy }} />
            <div className="text-footer">
              {props.selected ? (
                <div className="text-left">
                  <Icon name={IconName.CHECK_MARK} />
                  <span>Offer Applied!</span>
                </div>
              ) : (
                <button className="btn">Click to Apply</button>
              )}
              {props.promotion.expiry_date && (
                <div className="expiry">Expires: {props.promotion.expiry_date}</div>
              )}
            </div>
          </div>
        </div>
      </>
    </Selectable>
  );
};

export default PromotionBanner;
